export default (state) => Object.values(state.customers.data)
